import { render, staticRenderFns } from "./Matching.vue?vue&type=template&id=65cdeace"
import script from "./Matching.vue?vue&type=script&lang=js"
export * from "./Matching.vue?vue&type=script&lang=js"
import style0 from "./Matching.vue?vue&type=style&index=0&id=65cdeace&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports